import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Xmetadata } from '@utx/utx-access-client';

export interface WithdrawModalProps {
  onLayout: (event: any) => void;
}

export enum WithdrawStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type WithdrawStackParamList = {
  [WithdrawStackRoutes.Main]: WithdrawModalProps & {
    record?: any;
    onData: (data: any) => void;
    func?: (
      accountId: string,
      amount: number,
      currency: string,
      xmetadata: Xmetadata,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [WithdrawStackRoutes.Confirm]: WithdrawModalProps & {
    record?: any;
    data: any;
    func?: (
      accountId: string,
      amount: number,
      currency: string,
      xmetadata: Xmetadata,
      onSuccess?: (data: any) => void,
      onError?: (error: any) => void
    ) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [WithdrawStackRoutes.Placed]: WithdrawModalProps & {
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type WithdrawStackScreenProps<Screen extends keyof WithdrawStackParamList> = NativeStackScreenProps<WithdrawStackParamList, Screen>;
